import { App, ConfigProvider } from 'antd';
import ReactDOM from 'react-dom/client';
import 'styles/global.css';
import Apps from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider
    prefixCls="okvip"
    iconPrefixCls=""
    theme={{
      token: {
        colorPrimary: '#26A9E0',
        colorInfo: '#0053df',
        borderRadius: 4
      },
      components: {
        Button: {
          colorPrimary: '#26A9E0'
        },
        Layout: {
          headerHeight: 20
        }
      }
    }}
  >
    <App
      notification={{
        placement: 'topRight'
      }}
    >
      <Apps />
    </App>
  </ConfigProvider>
);
